import { render } from "./tw-divider.vue?vue&type=template&id=db4a34de"
import script from "./tw-divider.vue?vue&type=script&lang=js"
export * from "./tw-divider.vue?vue&type=script&lang=js"
script.render = render

export default script